import $ from 'jquery';
import RndGen from "./RndGen";

class Alert {
    static showAlert(type:string, userMsg:string){
      if (type == undefined){
        type = 'info';
      }
      var autoHide = false;
      if ((type == 'info') || (type == 'warning') || (type == 'success')){
        autoHide = true;
      }
      var closeButton = "";
      if (type != 'hourglass'){
        closeButton = '<a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>';
      }
      var alertDiv = $('<div>' + closeButton +  userMsg + '</div>');
      alertDiv.addClass('shown');

        $(alertDiv).addClass('alert alert-' + type);
      var alertID:string = RndGen.getRndString();
      $(alertDiv).addClass('alert_id_' + alertID);
      var alertHolder = $('.alert-holder');
      alertHolder.append(alertDiv);
      

      if (autoHide){
        setTimeout(function(){
          console.log("--------------------------- HIde by timeout")
          $(alertDiv).hide();
        }, 3000);
      }
      //console.log("--------------- SHOW alert:" + type + " - " + userMsg + " - " + alertID);
      return alertID;
    }    

  static hideAlert(alertID:string){
    //console.log("--------------- HIDE alert:" + alertID);
    var alertHolder = $('.alert-holder');
    var al = alertHolder.find('.alert_id_' + alertID);
    al.removeClass('shown');
    al.addClass('hidden');
    //al.hide();
  }

}

export default Alert